import { useState } from 'react';
import { useApi } from '../../hooks/useApi';
import logger from "../../utils/logger";
const initialState = {
  email: ''
};
function PasswordResetRequestForm() {
  const {
    request,
    showStatus,
    setStatus
  } = useApi();
  const [form, setForm] = useState(initialState);
  const [busy, setBusy] = useState(false);
  const handleSubmit = async event => {
    event.preventDefault();
    if (!form.email.trim()) {
      showStatus('error', 'Введите email.');
      return;
    }
    setBusy(true);
    setStatus(null);
    try {
      await request('/api/v1/auth/password-reset/request', {
        method: 'POST',
        body: JSON.stringify(form)
      });
      showStatus('success', 'Ссылка для сброса создана. В тестовом режиме проверьте backend-лог.');
      setForm(initialState);
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось создать ссылку для сброса пароля.');
    } finally {
      setBusy(false);
    }
  };
  return <form className="panel__form" onSubmit={handleSubmit} noValidate>
            <p className="panel__hint">
                Укажите email, чтобы получить ссылку для сброса пароля.
            </p>

            <label>
                Email
                <input type="email" value={form.email} onChange={event => setForm({
        email: event.target.value
      })} required />
        
            </label>

            <button type="submit" disabled={busy}>
                Сбросить пароль
            </button>
        </form>;
}
export default PasswordResetRequestForm;
